import { render, staticRenderFns } from "./LeaveLogNote.vue?vue&type=template&id=9abb4f08&scoped=true"
import script from "./LeaveLogNote.vue?vue&type=script&lang=js"
export * from "./LeaveLogNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abb4f08",
  null
  
)

export default component.exports